import React, { useState, forwardRef, useEffect } from "react";

import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import contractsAPI from "../../../../services/contracts";
import { InputNumber } from "primereact/inputnumber";

const UpdateContractTotalAmountModal = forwardRef((props, ref) => {
  //
  const [totalAmount, setTotalAmount] = useState("0");
  //
  useEffect(() => {
    setTotalAmount(props?.contract?.total_amount || "0");
  }, [props]);

  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Total à payer"
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        serviceAPI={contractsAPI}
        id={props?.contract?.id}
        data={{
          total_amount: parseFloat(totalAmount) || 0,
        }}
      >
        <InputNumber autoFocus={true} value={totalAmount || "0"} min={0} suffix={" " + props?.contract?.currency} showButtons className="w-full" onValueChange={(e) => {
          setTotalAmount(e.value);
        }} />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateContractTotalAmountModal;
